import _ from "lodash";
import data_all from "../../assets/parts/all.json";

/**
 * Class managing access to catalog data
 *
 * @class CatalogManager
 * @classdesc
 *  Provides access to Accessories Group data
 *  Provides access to Cosmetics Group data
 *  Provides access to Model Group data
 *  Provides access to Engine Group data
 *  Provides methods to get all parts data
 *  Provides methods to get all groups
 *  Provides methods to get details for parts
 */
export class CatalogManager {
  constructor(profileManager, assetManager) {
    this._profileManager = profileManager;
    this._assetManager = assetManager;
    this._modelCategory = null;
    this._engineCategory = null;
    this._accessories = null;
    this._cosmetics = null;
  }

  async initialize() {
    let data = JSON.parse(JSON.stringify(this._assetManager.getParts())); //cheap and dirty deep clone
    // let data = JSON.parse(JSON.stringify(data_all)); //cheap and dirty deep clone
    // let data = data_en;
    const lang = this._profileManager.lang;
    const groups = Object.values(data)
    for (const group of groups) {
      for (let category of group) {
        category.name = category[lang].name;
        if (category.parts) {
          category.parts.forEach((part) => {
            part.name = part[lang].name
            part.details = part[lang].details
            part.color = part[lang].color
            part.category = part[lang].category
          })
        }
      }
    }

    // process data
    this._modelCategory = data.modelGroupParts[0];
    this._engineCategory = data.engineGroupParts[0];
    this._accessories = filterNone(data.accessoriesGroupParts);
    this._cosmetics = filterNone(data.cosmeticsGroupParts);

    // flatten + aggregate inventory
    const categories = _.flatten([
      this._modelCategory,
      this._engineCategory,
      this._accessories,
      this._cosmetics,
    ]);

    this._inventory = _.flatMap(categories, (category) => category.parts);
  }

  get models() {
    return this._modelCategory.parts;
  }

  get engines() {
    return this._engineCategory.parts;
  }

  get accessories() {
    return filterRegion(this._accessories, this._profileManager.region);
  }

  get cosmetics() {
    return filterRegion(this._cosmetics, this._profileManager.region);
  }

  get inventory() {
    return this._inventory;
  }

  priceForPart(sku, modelSku) {
    // const prices = priceData;
    let price;
    let part = this._inventory.find((p) => p.sku === sku);
    if (part === undefined || part.prices === undefined) {
      return;
    }
    let model = modelSku || "BASE";
    price = part.prices[this._profileManager.region].find((p) => p.model === model);
    if (price === undefined) {
      price = part.prices[this._profileManager.region].find((p) => p.model === "BASE");
      if (price === undefined) {
        return;
      }
    }
    const finalPrice = parseFloat("" + price.value);
    if (isNaN(finalPrice)) {
      debugger
    }

    return finalPrice
  }

  findModel(sku) {
    return this.models.find((p) => p.sku === sku);
  }

  findEngine(sku) {
    return this.engines.find((p) => p.sku === sku);
  }
  isExcluded(bikeModel, region) {
    const bikeExcludedRegions = {
      AU: ["STD.903"],
      CA: [],
      DE: [],
      FR: [],
      JP: [],
      NZ: ["STD.903"],
      QC: [],
      US: [],
      GBL: [],
    };
    if (region && bikeExcludedRegions[region].includes(bikeModel)) {
      return true;
    }
    return false;
  }
}

function filterNone(partsGroups) {
  return partsGroups.map((partGroup) => {
    partGroup.parts = partGroup.parts.filter((part) => part.sku !== "NONE");
    return partGroup;
  });
}

function filterRegion(partsGroups, region) {
  // until we need something faster this will do
  const partsGroupsClone = JSON.parse(JSON.stringify(partsGroups));
  return partsGroupsClone.map((partGroup) => {
    partGroup.parts = partGroup.parts.filter((part) => {
      if (part.excludedRegions == undefined) {
        return true;
      }
      const regionFound = part.excludedRegions.some((code) => code == region);
      return !regionFound;
    });
    return partGroup;
  });
}



// WEBPACK FOOTER //
// ./src/managers/CatalogManager/index.js